import React from "react";
import Tooltip from "../tooltip";
import { Isvg } from "../../../components";

import { NavigatorAction } from "../../../flux";

const ToolButton = ({
  available,
  hoverMessage,
  img,
  location,
  route,
  text,
  unavailableMessage
}) => (
  <li>
    <button
      id={route}
      className="noButton"
      disabled={!available}
      onClick={() => {
        if (available) {
          NavigatorAction.replaceLast("new-assignment", { focus: route }, true);
          NavigatorAction.push(route);
        }
      }}
    >
      <span className="offscreen">{text}</span>
      <span className="offscreen">{hoverMessage}</span>
      <Tooltip
        content={available ? hoverMessage : unavailableMessage}
        location={location}
        className={`tool-box noselect ${!available ? "unavailable-tool" : ""}`}
      >
        <Isvg src={`/img/assignments/assets/img/${img}`} />
        <div className="text">{text}</div>
      </Tooltip>
    </button>
  </li>
);

export default ToolButton;
